/**
 * CBD HUT — Recently Viewed Products (Refresh/Dawn compatible)
 *
 * Extracted from sections/recently-viewed-products.liquid to reduce inline JS.
 *
 * How it works:
 * - Section outputs minimal config JSON (data-cbh-rvp-config) + data-* settings.
 * - This script finds every [data-cbh-recently-viewed] instance and renders cards.
 */

(function () {
  'use strict';

  var STORAGE_KEY = 'recentlyViewed';

  function esc(s) {
    return String(s || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function handleFromUrl(url) {
    try {
      var u = new URL(url, window.location.origin);
      var parts = u.pathname.split('/').filter(Boolean);
      var idx = parts.indexOf('products');
      if (idx > -1 && parts[idx + 1]) return parts[idx + 1];
    } catch (e) {}
    return '';
  }

  function normaliseHandleInput(item) {
    if (!item) return '';
    if (typeof item === 'string') return item;
    if (item.handle) return item.handle;
    if (item.url) return handleFromUrl(item.url);
    return '';
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      var fmt = window.Shopify.money_format || '£{{amount}}';
      return window.Shopify.formatMoney(cents, fmt);
    }
    var v = (Number(cents) || 0) / 100;
    return '£' + v.toFixed(2);
  }

  function cdnWidth(url, w) {
    if (!url) return '';
    if (url.indexOf('//') === 0) url = 'https:' + url;

    if (url.indexOf('width=') > -1) {
      return url.replace(/width=\d+/g, 'width=' + w);
    }

    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  async function fetchProductByHandle(handle) {
    var res = await fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' });
    if (!res.ok) throw new Error('Fetch failed: ' + handle);
    return await res.json();
  }

  function buildPriceHtml(p) {
    var v =
      (p.variants || []).find(function (x) {
        return x && x.available;
      }) ||
      (p.variants && p.variants[0]) ||
      null;

    var price = v ? v.price : p.price;
    var compare = v ? v.compare_at_price : p.compare_at_price;
    var onSale = compare && compare > price;

    if (onSale) {
      return (
        '\n        <div class="price price--on-sale" role="status">\n          <div class="price__container">\n            <div class="price__regular">\n              <span class="visually-hidden">Regular price</span>\n              <span class="price-item price-item--regular">' +
        formatMoney(compare) +
        '</span>\n            </div>\n            <div class="price__sale">\n              <span class="visually-hidden">Sale price</span>\n              <span class="price-item price-item--sale">' +
        formatMoney(price) +
        '</span>\n            </div>\n          </div>\n        </div>\n      '
      );
    }

    return (
      '\n      <div class="price" role="status">\n        <div class="price__container">\n          <div class="price__regular">\n            <span class="price-item price-item--regular">' +
      formatMoney(price) +
      '</span>\n          </div>\n        </div>\n      </div>\n    '
    );
  }

  function buildCardHtml(p, liClass, opts) {
    var title = esc(p.title || '');
    var url = p.url || '/products/' + (p.handle || '');
    var available = !!p.available;

    var img = p.featured_image || (Array.isArray(p.images) && p.images.length ? p.images[0] : '');

    if (img && img.indexOf('//') === 0) img = 'https:' + img;

    var badgeHtml =
      !available && opts.showSoldOutBadge
        ? '<div class="card__badge ' +
          esc(opts.badgePosition) +
          '">\n          <span class="badge badge--bottom-left color-' +
          esc(opts.soldOutScheme) +
          '">\n            ' +
          esc(opts.soldOutText) +
          '\n          </span>\n        </div>'
        : '';

    var cardStyle = opts.cardStyle;
    var cardColorScheme = opts.cardColorScheme;

    var cardClasses = 'card card--' + cardStyle + ' card--media';
    var cardInnerClasses = 'card__inner ratio';

    var cardExtraOuter = '';
    var cardExtraInner = '';

    if (cardStyle === 'card') {
      cardExtraOuter = ' color-' + cardColorScheme + ' gradient';
    } else {
      cardExtraInner = ' color-' + cardColorScheme + ' gradient';
    }

    var src = img ? cdnWidth(img, 533) : '';
    var srcset = img
      ? [
          cdnWidth(img, 165) + ' 165w',
          cdnWidth(img, 360) + ' 360w',
          cdnWidth(img, 533) + ' 533w',
          cdnWidth(img, 720) + ' 720w',
          cdnWidth(img, 940) + ' 940w',
          cdnWidth(img, 1066) + ' 1066w'
        ].join(', ')
      : '';

    var sizes =
      '(min-width: ' +
      opts.pageWidth +
      'px) ' +
      (opts.pageWidth - 130) / Math.max(1, opts.columnsDesktop) +
      'px, (min-width: 990px) calc((100vw - 130px) / ' +
      Math.max(1, opts.columnsDesktop) +
      '), (min-width: 750px) calc((100vw - 120px) / 3), calc((100vw - 35px) / 2)';

    return (
      '\n      <li class="' +
      esc(liClass) +
      '">\n        <div class="card-wrapper product-card-wrapper underline-links-hover">\n          <div class="' +
      esc(cardClasses + cardExtraOuter) +
      '">\n            <div class="' +
      esc(cardInnerClasses + cardExtraInner) +
      '" style="--ratio-percent: 100%;">\n              <div class="card__media">\n                <div class="media media--transparent media--square">\n                  ' +
      (img
        ? '<img\n                          srcset="' +
          esc(srcset) +
          '"\n                          src="' +
          esc(src) +
          '"\n                          sizes="' +
          esc(sizes) +
          '"\n                          alt="' +
          title +
          '"\n                          loading="lazy"\n                          decoding="async"\n                          width="533"\n                          height="533"\n                          class="motion-reduce"\n                        >'
        : '') +
      '\n                  <a href="' +
      esc(url) +
      '" class="full-unstyled-link" aria-label="' +
      title +
      '"></a>\n                </div>\n              </div>\n              ' +
      badgeHtml +
      '\n            </div>\n\n            <div class="card__content">\n              <div class="card__information">\n                <h3 class="card__heading h5">\n                  <a class="full-unstyled-link" href="' +
      esc(url) +
      '">' +
      title +
      '</a>\n                </h3>\n                <div class="card-information">\n                  ' +
      buildPriceHtml(p) +
      '\n                </div>\n              </div>\n            </div>\n\n          </div>\n        </div>\n      </li>\n    '
    );
  }

  function readInlineConfig(root) {
    var el = root.querySelector('[data-cbh-rvp-config]');
    if (!el) return {};
    try {
      return JSON.parse(el.textContent || '{}') || {};
    } catch (e) {
      return {};
    }
  }

  function parseIntSafe(v, fallback) {
    var n = parseInt(String(v || ''), 10);
    return Number.isFinite(n) ? n : fallback;
  }

  async function initInstance(root) {
    if (!root || root.dataset.cbhRvpInit === '1') return;
    root.dataset.cbhRvpInit = '1';

    var ul = root.querySelector('[data-cbh-rvp-list]');
    var emptyEl = root.querySelector('[data-cbh-rvp-empty]');
    var sliderButtons = root.querySelector('[data-cbh-rvp-buttons]');

    if (!ul) {
      root.setAttribute('data-ready', 'true');
      return;
    }

    var limit = parseIntSafe(root.getAttribute('data-limit'), 8);
    var columnsDesktop = parseIntSafe(root.getAttribute('data-columns-desktop'), 4);
    var columnsMobile = parseIntSafe(root.getAttribute('data-columns-mobile'), 2);
    var swipeOnMobile = (root.getAttribute('data-swipe-on-mobile') || 'true') === 'true';
    var enableDesktopSlider = (root.getAttribute('data-enable-desktop-slider') || 'false') === 'true';
    var hideIfEmpty = (root.getAttribute('data-hide-empty') || 'true') === 'true';
    var soldOutLast = (root.getAttribute('data-soldout-last') || 'true') === 'true';
    var currentHandle = String(root.getAttribute('data-current-handle') || '').trim();

    var opts = readInlineConfig(root);
    opts.columnsDesktop = columnsDesktop;
    opts.pageWidth = opts.pageWidth || 1200;
    opts.cardStyle = opts.cardStyle || 'standard';
    opts.cardColorScheme = opts.cardColorScheme || 'scheme-1';
    opts.badgePosition = opts.badgePosition || 'badge--bottom-left';
    opts.soldOutScheme = opts.soldOutScheme || 'scheme-1';
    opts.soldOutText = opts.soldOutText || 'Sold out';
    opts.showSoldOutBadge = typeof opts.showSoldOutBadge === 'boolean' ? opts.showSoldOutBadge : true;

    var raw = [];
    try {
      raw = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]') || [];
    } catch (e) {
      raw = [];
    }

    var handles = raw.map(normaliseHandleInput).filter(Boolean);

    if (currentHandle) {
      handles = handles.filter(function (h) {
        return h !== currentHandle;
      });
    }

    var seen = new Set();
    handles = handles
      .filter(function (h) {
        if (seen.has(h)) return false;
        seen.add(h);
        return true;
      })
      .slice(0, limit);

    if (!handles.length) {
      if (emptyEl) emptyEl.hidden = false;
      root.setAttribute('data-ready', 'true');
      root.style.display = '';
      if (hideIfEmpty) root.style.display = 'none';
      return;
    }

    var results = await Promise.all(
      handles.map(function (h) {
        return fetchProductByHandle(h).catch(function () {
          return null;
        });
      })
    );

    var products = [];
    var validHandles = [];

    for (var i = 0; i < results.length; i++) {
      if (results[i]) {
        products.push(results[i]);
        validHandles.push(handles[i]);
      }
    }

    if (validHandles.length !== handles.length) {
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(validHandles));
      } catch (e) {}
    }

    if (!products.length) {
      if (emptyEl) emptyEl.hidden = false;
      root.setAttribute('data-ready', 'true');
      root.style.display = '';
      if (hideIfEmpty) root.style.display = 'none';
      return;
    }

    if (soldOutLast) {
      products.sort(function (a, b) {
        var aa = a && a.available ? 0 : 1;
        var bb = b && b.available ? 0 : 1;
        return aa - bb;
      });
    }

    var useMobileSlider = swipeOnMobile && products.length > columnsMobile;
    var useDesktopSlider = enableDesktopSlider && products.length > columnsDesktop;

    if (useMobileSlider || useDesktopSlider) {
      ul.classList.add('slider');
      if (useMobileSlider) ul.classList.add('slider--tablet', 'grid--peek');
      if (useDesktopSlider) ul.classList.add('slider--desktop');
    }

    var liClass = 'grid__item';
    if (useMobileSlider || useDesktopSlider) liClass += ' slider__slide';

    ul.innerHTML = products
      .slice(0, limit)
      .map(function (p) {
        return buildCardHtml(p, liClass, opts);
      })
      .join('');

    if (sliderButtons) sliderButtons.hidden = !(useMobileSlider || useDesktopSlider);

    root.setAttribute('data-ready', 'true');
    root.style.display = '';
  }

  function initAll(scope) {
    var root = scope || document;
    var nodes = root.querySelectorAll('[data-cbh-recently-viewed]');
    if (!nodes || !nodes.length) return;
    nodes.forEach(function (n) {
      initInstance(n).catch(function () {
        n.setAttribute('data-ready', 'true');
        n.style.display = '';
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  // Theme editor support
  document.addEventListener('shopify:section:load', function (event) {
    if (!event || !event.target) return;
    initAll(event.target);
  });
})();
